import React from 'react';
import { matchPath, useHistory, useLocation } from 'react-router-dom';

import {
  TEACHERS_HOME_URL,
  TEACHERS_STUDENTS_DETAIL,
  TEACHERS_STUDENTS_LIST
} from 'config/urls';
import { get } from 'lodash';

import { parseParams, stringifyParams } from 'utils/urls';

import styles from './styles.module.scss';

const NavTitle = ({ title, subtitle, Icon }) => {
  const history = useHistory();
  const location = useLocation();

  const handleClickIcon = () => {
    const isStudentDetailRoute = matchPath(location.pathname, {
      path: TEACHERS_STUDENTS_DETAIL,
      exact: true
    });

    if (isStudentDetailRoute) {
      const searchParams = parseParams(history.location.search);
      const page = get(searchParams, 'page');

      history.push({
        pathname: TEACHERS_STUDENTS_LIST,
        search: stringifyParams({ page })
      });
      return;
    }

    history.push(TEACHERS_HOME_URL);
  };

  return (
    <div className={styles.navHeaderGroup}>
      <div className={styles.navTitleRow}>
        <button
          className={styles.backBtn}
          onClick={() => {
            handleClickIcon();
          }}
        >
          {Icon && <Icon className={styles.homeIcon} />}
        </button>
        <span>{title}</span>
      </div>
      <div className={styles.navSubtext}>{subtitle}</div>
    </div>
  );
};

export default NavTitle;
